import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import "./Questions.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { IQuestions } from "./IQuestions";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import QuestionsForm from "./QuestionsForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import {
  Button,
  ButtonGroup,
  IconButton,
  SvgIcon,
  TextField,
} from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listQuestions } from "../../Redux/Slices/Questions/ListQuestionsSlice";
import { clearAddQuestionsResponse } from "../../Redux/Slices/Questions/AddQuestionsSlice";
import {
  clearDeleteQuestionsResponse,
  deleteQuestions,
} from "../../Redux/Slices/Questions/DeleteQuestionsSlice";
import { clearEditQuestionsResponse } from "../../Redux/Slices/Questions/EditQuestionsSlice";
import { listQuestionType } from "../../Redux/Slices/QuestionType/ListQuestionTypeSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import {
  clearReadingPrompt,
  listReadingPrompt,
} from "../../Redux/Slices/ReadingPrompt/ListReadingPromptSlice";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import { listYearGroup } from "../../Redux/Slices/User/ListYearGroupSlice";
import {
  clearlistQuestionSubTypeResponse,
  listQuestionSubType,
} from "../../Redux/Slices/QuestionSubType/ListQuestionSubTypeSlice";
import ClearIcon from "@mui/icons-material/Clear";
import CustomFooter from "../../Components/Table/components/CustomFooter";
import { listYearlevel_map } from "../../Redux/Slices/Yearlevel_map/ListYearlevel_mapSlice";

interface QuestionsProps {}
interface Question {
  label: string;
  value: number;
}
interface YearList {
  // interface DifficultyOption {
  label: string;
  value: string;
}

// const DifficultyLevel: DifficultyOption[] = [
//   { label: "Easy", value: "easy" },
//   { label: "Moderate", value: "moderate" },
//   { label: "Hard", value: "difficult" },
// ];

const Questions: FunctionComponent<QuestionsProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IQuestions>({
    Status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listQuestionss } = useAppSelector(
    (state) => state.ListQuestionsSlice
  );
  const { data: addQuestions } = useAppSelector(
    (state) => state.AddQuestionsSlice
  );
  const { data: EditQuestions } = useAppSelector(
    (state) => state.EditQuestionsSlice
  );
  const { data: deleteQuestionss } = useAppSelector(
    (state) => state.DeleteQuestions
  );

  // user permisssion
  const { data: userPermissionlist } = useAppSelector(
    (state) => state.SideMenuPermission
  );
  const navigate = useNavigate();

  const to = "masters";

  const filteredList = userPermissionlist.Dashboard.filter(
    (item: any) => item.to === to
  );
  const fliterdata: any = filteredList[0]?.items;
  const finaldata = fliterdata[1];

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      headerName: "S.No",

      // renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "question",
      headerName: "Question",
      // renderHeader: () => <b>Questions</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "subType_name",
      headerName: "Sub Type",
      // renderHeader: () => <b>Questions</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "Question_type_name",
      headerName: "Question Type Name",

      // renderHeader: () => <b>Question Type</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "prompt",
      headerName: "Prompt",

      // renderHeader: () => <b>Prompt</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <div>
              {params?.row?.prompt === null ? "-" : params?.row?.prompt}
            </div>
          </>
        );
      },
    },
    {
      field: "instruction",
      headerName: "Instruction",

      // renderHeader: () => <b>Instruction</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <div>
              {params?.row?.instruction === null
                ? "-"
                : params?.row?.instruction}
            </div>
          </>
        );
      },
    },
    {
      field: "explanation",
      headerName: "Explanation",
      // renderHeader: () => <b>Explanation</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <div>
              {params?.row?.explanation === null
                ? "-"
                : params?.row?.explanation}
            </div>
          </>
        );
      },
    },

    // {
    //   field: "difficulty_level",
    //   headerName: "Difficulty Level",
    //   // renderHeader: () => <b>Difficulty Level</b>,
    //   flex: 1,
    //   type: "string",
    //   headerAlign: "left",
    // },
    // {
    //   field: "year_level",
    //   headerName: "Year Level",
    //   // renderHeader: () => <b>Difficulty Level</b>,
    //   flex: 1,
    //   type: "string",
    //   headerAlign: "left",
    // },
    {
      field: "source_type",
      headerName: "Source Type",
      // renderHeader: () => <b>Source Type</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "state",
      headerName: "Status",
      // renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",

      cellClassName: (params) =>
        `activename ${params.row.state === "active" ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === "active" ? "Active" : "Inactive",
    },
    {
      field: "action",
      headerName: "Action",
      // renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IQuestions>) => {
        return (
          <>
            <RemoveRedEyeIcon
              titleAccess="Review Exam question page"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/onlineexamtamplete", {
                  state: params.row,
                });
              }}
            ></RemoveRedEyeIcon>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row });
                setDialogOpen(true);
                dispatch(clearReadingPrompt());
                dispatch(listReadingPrompt({}));
                dispatch(
                  listQuestionSubType({
                    questiontype_id: params.row.questionType,
                  })
                );
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({
                  id: params.id,
                  // name: params?.row?.explanation,
                });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const Questions = Array.isArray(listQuestionss?.data)
    ? listQuestionss?.data.map((user, index) => ({ ...user, index: index + 1 }))
    : [];
  const [isActive, setIsActive] = useState(true);
  const filteredfortrue = Questions?.filter((item) => item.Status === true);
  const [filteredData, setFilteredData] = useState(filteredfortrue);
  useEffect(() => {
    const filteredfortrue = Questions?.filter((item) => item.Status === true);
    setIsActive(true);
    setFilteredData(filteredfortrue);
  }, [listQuestionss?.data]);

  const handleFilter = (status: boolean) => {
    const filtered = Questions?.filter((item) => item.Status === status);
    setFilteredData(filtered);
  };

  useEffect(() => {
    dispatch(listQuestionType());
    // dispatch(listQuestions({}));
    dispatch(listYearlevel_map());
    dispatch(listReadingPrompt({}));
    // dispatch(listSideMenuPermission());
    dispatch(listYearGroup());
  }, [dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddQuestionsResponse());
      dispatch(clearEditQuestionsResponse());
      dispatch(clearDeleteQuestionsResponse());
      dispatch(clearlistQuestionSubTypeResponse());
    };
  }, [dispatch]);

  const { data: listQuestionstype } = useAppSelector(
    (state) => state.ListQuestionTypeSlice
  );

  const QuestionList: any = Array.isArray(listQuestionstype?.data)
    ? listQuestionstype?.data
        ?.filter((role) => role.Status !== false) // Filter out roles where status is false
        .map((listQuestions) => ({
          label: listQuestions?.name!,
          value: listQuestions.id,
        }))
    : [];
  const [selectedValue, setSelectedValue] = useState<Question | null>(() =>
    JSON.parse(sessionStorage.getItem("selectedValue") || "null")
  );
  const [selectedValuesub, setSelectedValuesub] = useState<Question | null>(
    () => JSON.parse(sessionStorage.getItem("selectedValuesub") || "null")
  );

  const [selectedLevel, setSelectedLevel] = useState<YearList | null>(() =>
    JSON.parse(sessionStorage.getItem("selectedLevel") || "null")
  );
  // const [selectedLevel, setSelectedLevel] = useState<DifficultyOption | null>(
  //   () => JSON.parse(sessionStorage.getItem("selectedLevel") || "null")
  // );

  const [formValues, setFormValues] = useState(() => {
    return (
      JSON.parse(sessionStorage.getItem("formValues") || "{}") || {
        question: "",
        prompt: "",
        instruction: "",
      }
    );
  });

  // question count

  const [currentPage, setCurrentPage] = useState(1); // Start from page 1
  const pageSize = 20;

  const handleNext = () => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);

    const payload: any = { page: nextPage, page_size: 20 };

    if (selectedLevel) {
      payload.year_level = selectedLevel.value;
      // payload.year_level = selectedLevel.value;
    }
    if (selectedValue) {
      payload.questionType = selectedValue.value;
    }
    if (selectedValuesub) {
      payload.subType = selectedValuesub.value;
    }
    if (formValues.question || formValues.prompt || formValues.instruction) {
      payload.question = formValues.question;
      payload.prompt = formValues.prompt;
      payload.instruction = formValues.instruction;
    }

    // If at least one field is filled, dispatch API call
    dispatch(listQuestions(Object.keys(payload).length > 0 ? payload : {}));
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      setCurrentPage(prevPage);

      const payload: any = { page: prevPage, page_size: 20 };

      if (selectedLevel) {
        payload.year_level = selectedLevel.value;
        // payload.year_level = selectedLevel.value;
      }
      if (selectedValue) {
        payload.questionType = selectedValue.value;
      }
      if (selectedValuesub) {
        payload.subType = selectedValuesub.value;
      }
      if (formValues.question || formValues.prompt || formValues.instruction) {
        payload.question = formValues.question;
        payload.prompt = formValues.prompt;
        payload.instruction = formValues.instruction;
      }

      // If at least one field is filled, dispatch API call
      dispatch(listQuestions(Object.keys(payload).length > 0 ? payload : {}));
    }
  };
  // Function to trigger API call with proper conditions
  const triggerApiCall = () => {
    const payload: any = { page: 1, page_size: 20 };
    setCurrentPage(1);

    if (selectedLevel) {
      payload.year_level = selectedLevel.value;
      // payload.year_level = selectedLevel.value;
    }
    if (selectedValue) {
      payload.questionType = selectedValue.value;
    }
    if (selectedValuesub) {
      payload.subType = selectedValuesub.value;
    }
    if (formValues.question || formValues.prompt || formValues.instruction) {
      payload.question = formValues.question;
      payload.prompt = formValues.prompt;
      payload.instruction = formValues.instruction;
    }

    // If at least one field is filled, dispatch API call
    dispatch(listQuestions(Object.keys(payload).length > 0 ? payload : {}));
  };

  // Call API when dependencies change
  useEffect(() => {
    triggerApiCall();
  }, [
    selectedValue,
    selectedValuesub,
    selectedLevel,
    formValues,
    addQuestions,
    EditQuestions,
    deleteQuestionss,
  ]);

  const handleChange =
    (field: "question" | "prompt" | "instruction") =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setFormValues((prev: any) => {
        const updated = { ...prev, [field]: value };
        sessionStorage.setItem("formValues", JSON.stringify(updated));
        return updated;
      });
    };

  const ListYearSliceLoading = useAppSelector(
    (state) => state.ListYearGroupSlice
  );
  const ListYear = ListYearSliceLoading?.data;

  const YearList = Array.isArray(ListYear?.data)
    ? ListYear?.data?.map((listExams) => ({
        label: listExams?.year_group!,
        value: listExams?.year_group!,
      }))
    : [];
  const { data: listQuestionssub } = useAppSelector(
    (state) => state.ListQuestionSubTypeSlice
  );
  const QuestionsubList = Array.isArray(listQuestionssub?.data)
    ? listQuestionssub?.data
        ?.filter((role) => role.status !== false) // Filter out roles where status is false
        .map((listQuestions) => ({
          label: listQuestions?.subtype_name!,
          value: listQuestions.id,
        }))
    : [];
  useEffect(() => {
    if (selectedValue) {
      dispatch(listQuestionSubType({ questiontype_id: selectedValue?.value }));
    }
  }, [selectedValue]);

  return (
    <>
      <Table
        rows={filteredData ?? []}
        columns={columns}
        // disableColumnMenu={false}
        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
          },
        }}
      >
        <CustomToolbar sx={{ display: "block" }}>
          <div style={{ display: "flex", gap: "10px" }}>
            {/* <h6>Questions</h6> */}
            <h6></h6>
            {/* Active & Inactive Button */}

            <ButtonGroup
              variant="contained"
              className="active_Btn"
              sx={{
                border: "none", // Ensures no border around the ButtonGroup
                "& .MuiButton-root": {
                  // Targets individual Button components inside the ButtonGroup
                  border: "none", // Removes the border from buttons
                },
              }}
            >
              <Button
                className="active_Btn"
                onClick={() => {
                  handleFilter(true);
                  setIsActive(true);
                }}
                sx={{
                  backgroundColor: isActive === true ? "#1976d2" : "#fff",
                  color: isActive === true ? "#fff" : "#000",
                  "&:hover": {
                    backgroundColor: isActive === true ? "#1976d2" : "#f5f5f5",
                  },
                }}
              >
                Active
              </Button>

              <Button
                onClick={() => {
                  handleFilter(false);
                  setIsActive(false);
                }}
                sx={{
                  backgroundColor: isActive === false ? "#1976d2" : "#fff",
                  color: isActive === false ? "#fff" : "#000",
                  "&:hover": {
                    backgroundColor: isActive === false ? "#1976d2" : "#f5f5f5",
                  },
                }}
              >
                Inactive
              </Button>
            </ButtonGroup>
            {/* <TableSearch /> */}
            <ButtonField
              disabled={finaldata?.permissions?.add === false}
              className="tabel_add_new_button"
              onClick={() => setDialogOpen(true)}
              toolTip="Add new"
            >
              Add new
            </ButtonField>
            <IconButtonField
              className="refresh_btn"
              toolTip="Refresh"
              onClick={() => {
                const payload: any = { page: 1, page_size: 20 };
                if (selectedLevel) {
                  payload.year_level = selectedLevel.value;
                  // payload.year_level = selectedLevel.value;
                }
                if (selectedValue) {
                  payload.questionType = selectedValue.value;
                }
                if (selectedValuesub) {
                  payload.subType = selectedValuesub.value;
                }
                if (
                  formValues.question ||
                  formValues.prompt ||
                  formValues.instruction
                ) {
                  payload.question = formValues.question;
                  payload.prompt = formValues.prompt;
                  payload.instruction = formValues.instruction;
                }

                // If at least one field is filled, dispatch API call
                dispatch(
                  listQuestions(Object.keys(payload).length > 0 ? payload : {})
                );
              }}
            >
              <SvgIcon
                className="refresh_svg_icon"
                component={RefreshButton}
                inheritViewBox
              />
            </IconButtonField>
          </div>
          <br></br>
          <div style={{ display: "flex", gap: "10px" }}>
            <FormControl
              size="small"
              variant="outlined"
              sx={{ width: "200px", marginRight: "10px", position: "relative" }}
            >
              <InputLabel id="question-select-label">
                Select Question Type
              </InputLabel>
              <Select
                label="Select Question Type"
                labelId="question-select-label"
                value={selectedValue ? selectedValue.value : ""}
                onChange={(e) => {
                  const selected =
                    QuestionList?.find(
                      (q: any) => q?.value === e.target.value
                    ) || null;
                  setSelectedValue(selected);
                  dispatch(
                    listQuestionSubType({ questiontype_id: selected?.value })
                  );
                  sessionStorage.setItem(
                    "selectedValue",
                    JSON.stringify(selected)
                  );
                  setSelectedLevel(null);
                  setFormValues({ question: "", prompt: "", instruction: "" });
                  sessionStorage.setItem(
                    "formValues",
                    JSON.stringify({
                      question: "",
                      prompt: "",
                      instruction: "",
                    })
                  );
                }}
              >
                {QuestionList?.length > 0 ? (
                  QuestionList?.map((question: any) => (
                    <MenuItem key={question.value} value={question.value}>
                      {question.label}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No Questions Available</MenuItem>
                )}
              </Select>

              {/* Clear Icon */}
              {selectedValue && (
                <IconButton
                  size="small"
                  sx={{
                    position: "absolute",
                    right: 5,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1,
                    marginRight: "15px",
                  }}
                  onClick={() => {
                    setSelectedValue(null);
                    sessionStorage.removeItem("selectedValue");
                    setSelectedLevel(null);
                    setSelectedValuesub(null);
                    setFormValues({
                      question: "",
                      prompt: "",
                      instruction: "",
                    });
                    sessionStorage.setItem(
                      "formValues",
                      JSON.stringify({
                        question: "",
                        prompt: "",
                        instruction: "",
                      })
                    );
                  }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              )}
            </FormControl>

            <FormControl
              size="small"
              variant="outlined"
              sx={{ width: "200px", marginRight: "10px", position: "relative" }}
            >
              <InputLabel id="questionsub-select-label">
                Select Question SubType
              </InputLabel>
              <Select
                label="Select Question SubType"
                labelId="questionsub-select-label"
                value={selectedValuesub ? selectedValuesub.value : ""}
                onChange={(e) => {
                  const selected: any =
                    QuestionsubList?.find(
                      (q: any) => q?.value === e.target.value
                    ) || null;
                  setSelectedValuesub(selected);
                  sessionStorage.setItem(
                    "selectedValuesub",
                    JSON.stringify(selected)
                  );
                }}
              >
                {(QuestionsubList?.length ?? 0) > 0 ? (
                  QuestionsubList?.map((question: any) => (
                    <MenuItem key={question.value} value={question.value}>
                      {question.label}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No Questions Subtype Available</MenuItem>
                )}
              </Select>

              {/* Clear Icon */}
              {selectedValuesub && (
                <IconButton
                  size="small"
                  sx={{
                    position: "absolute",
                    right: 5,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1,
                    marginRight: "15px",
                  }}
                  onClick={() => {
                    setSelectedValuesub(null);
                    sessionStorage.removeItem("selectedValuesub");
                  }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              )}
            </FormControl>
            <FormControl
              size="small"
              variant="outlined"
              sx={{ width: "200px", marginRight: "10px", position: "relative" }}
            >
              <InputLabel id="difficulty-select-label">
                Select Year Level
              </InputLabel>
              <Select
                label="Select Year Level"
                labelId="difficulty-select-label"
                value={selectedLevel ? selectedLevel.value : ""}
                onChange={(e) => {
                  const selected =
                    YearList?.find((q: any) => q?.value === e.target.value) ||
                    null;
                  setSelectedLevel(selected);
                  sessionStorage.setItem(
                    "selectedLevel",
                    JSON.stringify(selected)
                  );
                }}
              >
                {YearList ? (
                  YearList.map((question: any) => (
                    <MenuItem key={question.value} value={question.value}>
                      {question.label}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No Questions Available</MenuItem>
                )}
              </Select>

              {/* Clear Button */}
              {selectedLevel && (
                <IconButton
                  size="small"
                  sx={{
                    position: "absolute",
                    right: 5,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1,
                    marginRight: "15px",
                  }}
                  onClick={() => {
                    setSelectedLevel(null);
                    sessionStorage.removeItem("selectedLevel");
                  }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              )}
            </FormControl>
            <TextField
              sx={{ marginRight: "10px" }}
              size="small"
              id="question-field"
              label="Question"
              variant="outlined"
              value={formValues.question}
              onChange={handleChange("question")}
            />
            <TextField
              size="small"
              sx={{ marginRight: "10px" }}
              id="prompt-field"
              label="Prompt"
              variant="outlined"
              value={formValues.prompt}
              onChange={handleChange("prompt")}
            />
            <TextField
              size="small"
              id="instruction-field"
              label="Instruction"
              variant="outlined"
              value={formValues.instruction}
              onChange={handleChange("instruction")}
            />
          </div>
        </CustomToolbar>

        <CustomFooter className="bottom_toolbar">
          <ButtonField
            variant="contained"
            sx={{
              color: "#009DFF",
              border: "1px soild #009DFF",
              backgroundColor: "white", // Same color on hover to prevent change
              marginRight: "10px",
              "&:hover": {
                backgroundColor: "white", // Same color on hover to prevent change
              },
            }}
            onClick={handlePrevious}
            disabled={currentPage === 1} // Disable on first page
          >
            Pervious
          </ButtonField>
          <ButtonField
            variant="contained"
            sx={{
              color: "white",
              "&:hover": {
                backgroundColor: "#009DFF", // Same color on hover to prevent change
              },
            }}
            onClick={handleNext}
          >
            Next
          </ButtonField>
        </CustomFooter>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${initialValues?.id ? "Update" : "Add"} Questions`}
        Dialog_Content={
          <QuestionsForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog response={addQuestions} parentDialog={setDialogOpen} />
      <ResponseDialog response={EditQuestions} parentDialog={setDialogOpen} />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteQuestions(deleteDialogData.id));
        }}
        response={deleteQuestionss}
      />
    </>
  );
};

export default Questions;
